import { 
  Container, 
  Grid, 
  Text, 
  Stack, 
  Anchor, 
  Divider,
  Box,
  ThemeIcon,

} from '@mantine/core'
import { footerStyles } from './Footer.styles'
import { 
  IconCar, 
  IconPhone, 
  IconMail, 
  IconMapPin, 
  IconClock,

} from '@tabler/icons-react'
import { useStorageContext } from '@/contexts/StorageContext'

export function Footer() {
  const storage = useStorageContext()


  return (
    <Box style={footerStyles.wrapper}>
      <Container size="xl" py="xl">
        <Grid>
          <Grid.Col span={{ base: 12, sm: 6, md: 2 }}>
            <Stack gap="md">
              <Box style={{ display: 'flex', alignItems: 'center', gap: 'var(--mantine-spacing-xs)', marginBottom: 'var(--mantine-spacing-xs)' }}>
                <IconCar size={24} color="var(--mantine-color-blue-4)" />
                <Text size="lg" fw={700} style={{ color: 'var(--mantine-color-white)' }}>
                  Авто Эксперт
                </Text>
              </Box>
              <Text size="sm" c="dimmed" maw={250} style={{ lineHeight: 1.6, color: 'var(--mantine-color-gray-4)' }}>
                Технический осмотр автомобиля с выдачей экспертного заключения государственного образца.
              </Text>
              
            </Stack>
          </Grid.Col>

          <Grid.Col span={{ base: 12, sm: 6, md: 2 }}>
            <Stack gap="md">
              <Text fw={600} size="md">
                Услуги
              </Text>
              <Stack gap="xs">
                <Anchor href="/services" c="dimmed" size="sm">
                  Технический осмотр автомобиля
                </Anchor>

              </Stack>
            </Stack>
          </Grid.Col>

          <Grid.Col span={{ base: 12, sm: 6, md: 2 }}>
            <Stack gap="md">
              <Text fw={600} size="md">
                Информация
              </Text>
              <Stack gap="xs">
                <Anchor href="/about" c="dimmed" size="sm">
                  О компании
                </Anchor>
                <Anchor href="/documents" c="dimmed" size="sm">
                  Документы
                </Anchor>
                <Anchor href="/booking" c="dimmed" size="sm">
                  Записаться
                </Anchor>
              </Stack>
            </Stack>
          </Grid.Col>

          <Grid.Col span={{ base: 12, sm: 6, md: 6 }} style={footerStyles.contactItem}>
            <Stack gap="0">

              <Stack gap="0">
                <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 'var(--mantine-spacing-xs)' }}>
                  <ThemeIcon size="sm" variant="subtle" color="green">
                    <IconPhone size={16} />
                  </ThemeIcon>
                  <Stack gap={0}>
                    <Text size="sm" fw={500}>{storage.barndInfo.phone}</Text>
                  </Stack>
                </Box>

                <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 'var(--mantine-spacing-xs)' }}>
                  <ThemeIcon size="sm" variant="subtle" color="blue">
                    <IconMail size={16} />
                  </ThemeIcon>
                  <Text size="sm" c="dimmed">{storage.barndInfo.email}</Text>
                </Box>

                <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 'var(--mantine-spacing-xs)' }}>
                  <ThemeIcon size="sm" variant="subtle" color="orange">
                    <IconMapPin size={16} />
                  </ThemeIcon>
                  <Text size="sm" c="dimmed">
                  {storage.barndInfo.address}
                  </Text>
                </Box>

                <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 'var(--mantine-spacing-xs)' }}>
                  <ThemeIcon size="sm" variant="subtle" color="violet">
                    <IconClock size={16} />
                  </ThemeIcon>
                  <Stack gap={0}>
                    <Text size="sm" c="dimmed">Пн-Сб: 9:00 - 18:00</Text>
                    <Text size="sm" c="dimmed">Вс: выходной</Text>
                  </Stack>
                </Box>
                <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 'var(--mantine-spacing-xs)' }}>
                  <ThemeIcon size="sm" variant="subtle" color="violet">
                    <IconMapPin size={16} />
                  </ThemeIcon>
                  <Text size="sm" c="dimmed">
                    {storage.barndInfo.gps}
                  </Text>
                </Box>
              </Stack>
            </Stack>
          </Grid.Col>
        </Grid>

        <Divider my="xl" color="gray.6" />

        <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
          <Text size="sm" c="dimmed">
            © 2025  ООО "Авто Эксперт". Все права защищены. v{storage.settings.version}
          </Text>
          <Box style={{ display: 'flex', gap: 'var(--mantine-spacing-md)' }}>

          </Box>
        </Box>
      </Container>
    </Box>
  )
}